import React from 'react'
import PropTypes from 'prop-types'
import SimpleReactCalendar from 'simple-react-calendar'
import Icon from 'components/Icon'
import range from 'lodash/range'
import classnames from 'classnames'
import partial from 'utils/partial'
import startOfMonth from 'date-fns/start_of_month'
import endOfMonth from 'date-fns/end_of_month'
import subYears from 'date-fns/sub_years'
import addYears from 'date-fns/add_years'
import getYear from 'date-fns/get_year'
import format from 'date-fns/format'
import isWithinRange from 'date-fns/is_within_range'

class MonthHeaderComponent extends React.Component {
  render() {
    return null
  }
}

export default class MonthCalendar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    selected: PropTypes.object,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    today: PropTypes.instanceOf(Date),
    onApply: PropTypes.func,
    onSelect: PropTypes.func
  }

  render() {
    const {className} = this.props
    const classNames = classnames('calendar-range-month', className)

    return (
      <div className={classNames}>
        {this.renderYearSelector()}
        <div className='calendar-range-month_months'>
          {this.renderMonths()}
        </div>
      </div>
    )
  }

  renderYearSelector() {
    const {maxDate, minDate} = this.props
    const start = this.getStartDate()
    const previousYear = subYears(start, 1)
    const nextYear = addYears(start, 1)

    const isPreviousDisabled = getYear(start) <= getYear(minDate)
    const setPreviousYear = !isPreviousDisabled ? partial(this.setYear, previousYear) : null

    const isNextDisabled = getYear(start) >= getYear(maxDate)
    const setNextYear = !isNextDisabled ? partial(this.setYear, nextYear) : null

    const prevClassNames = classnames('calendar-header_button is-prev', {
      'is-disabled': isPreviousDisabled
    })
    const nextClassNames = classnames('calendar-header_button is-next', {
      'is-disabled': isNextDisabled
    })
    return (
      <div className='calendar-range-month_year'>
        <button className={prevClassNames} onClick={setPreviousYear}>
          <Icon
            className='calendar_icon-left'
            name='chevron'
            size='10px'
          />
        </button>
        <div className='calendar-range-month_year_title'>
          {getYear(start)}
        </div>
        <button className={nextClassNames} onClick={setNextYear}>
          <Icon
            className='calendar_icon-right'
            name='chevron'
            size='10px'
          />
        </button>
      </div>
    )
  }

  renderMonths() {
    const {minDate, maxDate} = this.props
    const start = this.getStartDate()
    const endOfMax = endOfMonth(maxDate)

    return range(0, 12).map(month => {
      const activeMonth = new Date(getYear(start), month, 1)
      const isActive = isWithinRange(activeMonth, minDate || new Date(0), endOfMax)
      const classNames = classnames('calendar-range-month_item', {
        'is-active': isActive
      })
      return (
        <div
          className={classNames}
          onClick={isActive ? partial(this.onMonthSelect, activeMonth) : null}
          key={month}
        >
          <div className='calendar-range-month_item_title'>
            {format(activeMonth, 'MMMM')}
          </div>
          <SimpleReactCalendar
            disableDaysOfWeek
            activeMonth={activeMonth}
            MonthHeaderComponent={MonthHeaderComponent}
            minDate={minDate}
            maxDate={maxDate}
          />
        </div>
      )
    })
  }

  onMonthSelect = month => {
    const {onApply} = this.props

    onApply({
      start: startOfMonth(month),
      end: endOfMonth(month)
    })
  }

  setYear = year => {
    const {onSelect} = this.props

    onSelect({start: year, end: year})
  }

  getStartDate() {
    const {today, selected: {start}} = this.props

    return start || today
  }
}



// WEBPACK FOOTER //
// ./client/components/Calendar/MonthCalendar.js